import { GeographicCoordinates } from '@lune-climate/lune'

import { coordinatesToMapboxPosition, fixLonRoute } from './mapWithRouteUtils'

type RouteWithLegIndex = {
    legIndex?: number
}

type MapPosition = [number, number]

const getPositionKey = ([longitude, latitude]: MapPosition): string => `${longitude}:${latitude}`

export const getRouteLegIndex = (routeIndex: number, route: RouteWithLegIndex): number =>
    route.legIndex ?? routeIndex + 1

export const getActiveMapRoute = <TRoute extends RouteWithLegIndex>({
    routes,
    activeLegIndex,
    emphasizeActiveLeg,
}: {
    routes: TRoute[]
    activeLegIndex?: number | null
    emphasizeActiveLeg?: boolean
}): TRoute | null => {
    if (!emphasizeActiveLeg || activeLegIndex == null) {
        return null
    }

    return (
        routes.find((route, routeIndex) => {
            return getRouteLegIndex(routeIndex, route) === activeLegIndex
        }) ?? null
    )
}

export const getRouteMarkerCoordinates = (coordinates: GeographicCoordinates[]): MapPosition[] =>
    fixLonRoute(coordinates).map(coordinatesToMapboxPosition)

export const getConnectionMarkerCoordinates = ({
    routes,
    markerMode,
    excludeCoordinates,
}: {
    routes: MapPosition[][]
    markerMode: 'waypoints' | 'route-endpoints'
    excludeCoordinates: MapPosition[]
}): MapPosition[] => {
    const excludedKeys = new Set(excludeCoordinates.map(getPositionKey))
    const seenKeys = new Set<string>()

    return routes
        .flatMap((route) => {
            if (route.length < 2) {
                return []
            }

            return markerMode === 'waypoints' ? route : [route[0], route.at(-1)!]
        })
        .filter((coordinate) => {
            const key = getPositionKey(coordinate)

            if (excludedKeys.has(key) || seenKeys.has(key)) {
                return false
            }

            seenKeys.add(key)
            return true
        })
}
